module.exports = __webpack_public_path__ + "static/media/logo-bicc-gray.670169b6.png";